export function* uniqueIdMaker(
    prefix: string
): Generator<string, string, string> {
    let i = 0;
    while (true) {
        i++;
        yield `${prefix}${i}`;
    }
}
